<template>
<v-container>
  <v-card style="border-radius: 8px;">
    <v-container>
    <v-card-title>
      <!-- <v-btn flat round color="primary" @click="createAssest($event)">+ Add new Asset</v-btn> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="cusers"
      :search="search"
    >
      <template v-slot:items="props">
        <td>{{ props.item.userid }}</td>
        <td>{{ props.item.username }}</td>
        <td>{{ props.item.usercreatedon }}</td>
        <td>{{ props.item.lastuserinteraction }}</td>   
        <td @click="showvars(props.item.vars,props.item.docId)" style="cursor:pointer; text-decoration:underline;">{{ props.item.varscount }}</td>  
        <td>{{ props.item.optinsource }}</td>     
        <!-- <td class="justify-center">
          <v-icon
            small
            @click="deleteItem(props.item)">
            delete
          </v-icon>
        </td> -->
      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    </v-container>
  </v-card>
  <v-menu v-model="openvars"
        :close-on-click = "false"
        :position-x="x"
        :position-y="y"
        offset-x
        :close-on-content-click="false"
        :nudge-width="1000">
    <v-card>
    <v-card-title>
      <div>
        <h3 class="subheading">List of user variables</h3>
      </div>
      <v-spacer></v-spacer> 
                <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
        <template class="ml-4">
           <v-btn v-if="!newvar" icon @click="addnewVar" class="ml-4"><v-icon>add</v-icon></v-btn>
           <v-btn v-if="newvar" icon @click="cancelnewVar" class="ml-4"><v-icon>cancel</v-icon></v-btn>
        </template>
    <v-card v-if="newvar" flat>
      <v-container grid-list-xl>
        <div v-if="newvar" class="caption grey--text">Add new variable</div>
      <v-layout v-if="newvar">
       <v-flex xs6>
        <v-card flat style="border-radius:8px;">
          <v-text-field
            v-model="newvarkey"
            counter=50
          ></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card flat style="border-radius:8px;">
          <v-text-field
            v-model="newvarval"
            counter=50
            append-outer-icon="add"
            @click:append-outer="savenewuservar"
          ></v-text-field>
        </v-card>
      </v-flex>
      </v-layout>
      </v-container>
    </v-card>
    <v-container grid-list-xl>
      <v-layout class="mt-0">
      <v-flex xs6>
        <v-card flat style="border-radius:8px;" class="mt-0" v-for="(varkey,index) in varkeys" :key="varkey">
          <v-text-field
            v-model="varkeys[index]"
            disabled
          ></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card flat style="border-radius:8px;" class="mt-0" v-for="(varval,index) in varvals" :key="varval">
          <v-text-field
            v-model="varvals[index]"
            counter=50
            append-outer-icon="delete"
            @click:append-outer="deletevar(index)"
          ></v-text-field>
        </v-card>
      </v-flex>
      </v-layout>
      <v-card-actions class="ma-0">
          <v-spacer></v-spacer>                  
              <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
              <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
      </v-card-actions> 
    </v-container>
    </v-card>
</v-menu> 
  </v-container>
</template>

<script>
import {str,firebase} from '@/plugins/firebase.js';
import store from '../store';
  export default {
    data () {
      return {
        x:null,
        y:null,
        search: '',
        newvar:false,
        newvarval:null,
        newvarkey:null,
        uservars:{},
        varsDoc:null,
        varkeys:[],
        varvals:[],
        headers: [
          { text: 'Id', align: 'left', value: 'userid'},
          { text: 'Name', align: 'left', value: 'username'},
          { text: 'Created On', align: 'left', value: 'usercreatedon'},
          { text: 'Last Interaction', align: 'left', value: 'lastuserinteraction' },
          { text: 'Vars', align: 'left', value: 'uservars',sortable: false },
          { text: 'Optin Source', align: 'left', value: 'optinsource' },
          // { text: 'Delete User', align: 'left', value: 'name', sortable: false}
        ]
      }
    },
    methods:{
      showvars(vars,docid){
        console.log(vars)
        this.x = 200
        this.y = 100
        let status = true
        this.uservars = vars
        this.varsDoc = docid
       // this.varindex = this.cusers.map(e => e.userid).indexOf(userid)
        this.varkeys = Object.keys(vars)
        this.varvals = Object.values(vars)
        this.$store.dispatch('aresponsemenuStatusChange',status)
        console.log("showing vars")
      },
      cancelCard(){
        let status = false
        this.$store.dispatch('aresponsemenuStatusChange',status)
      },
      saveCard(){
        let setvars ={}
        for(let i in this.varvals){         
          setvars[this.varkeys[i]] = this.varvals[i]
        }
        console.log(setvars)
        let docid = this.varsDoc
        this.$store.dispatch('asaveUservars',{setvars,docid})
        let status = false
        this.$store.dispatch('aresponsemenuStatusChange',status)
      },
      deletevar(index){
        let setvars ={}
        this.varkeys.splice(index,1)
        this.varvals.splice(index,1)
      },
      addnewVar(){
        this.newvar = true
        this.newvarval = null
        this.newvarkey = null
      },
      cancelnewVar(){
        this.newvar = false
      },
      savenewuservar(){
        this.varkeys.push(this.newvarkey)
        this.varvals.push(this.newvarval)
        this.newvar = false
      }

    },
    computed:{
      openvars(){
            return this.$store.state.responseMenuStatus
        },
        cusers(){
            return this.$store.state.pageusers
        }
    }
  }
</script>